import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { FuseConfirmationService } from '../../../../@fuse/services/confirmation/confirmation.service';

@Injectable()
export class EditObjectGuard implements CanDeactivate<any> {

    constructor(
        private _fuseConfirmationService: FuseConfirmationService,
        private translocoService: TranslocoService
    ) { }

    async canDeactivate(component: any, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Promise<boolean> {
        // Si se intenta salir porque se ha refrescado en la pagina de edición se deja salir
        if (nextState.root.queryParams.force && nextState.root.queryParams.force !== 'false') {
            return true;
        }

        if (component.hasChanges === false) {
            return true;
        }

        const dialogRef = this._fuseConfirmationService.open({
            title: this.translocoService.translate('unsavedChanges'),
            message: this.translocoService.translate('exitWithUnsavedChanges'),
            actions: {
                confirm: {
                    label: this.translocoService.translate('exitWithoutSaving')
                },
                cancel: {
                    label: this.translocoService.translate('cancel')
                }
            }
        });

        return new Promise<boolean>((resolve) => {
            dialogRef.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        });
    }
}
